import React, { useRef, useState, useEffect } from "react";
import SlideInOutText2 from "../effects/SlideInOutText2";

const data = [
  { imgSrc: "/assets/sports1.png", time: "2004", place: "Yangon" },
  { imgSrc: "/assets/sports2.jpg", time: "2008", place: "Tashkent" },
  { imgSrc: "/assets/sports9.jpg", time: "2010", place: "Tashkent" },
  { imgSrc: "/assets/sports4.jpg", time: "2016", place: "Maastricht" },
  { imgSrc: "/assets/sports3.jpg", time: "2017", place: "Seoul" },
  { imgSrc: "/assets/sports5.png", time: "2020", place: "Seoul" },
  // { imgSrc: "/assets/sports6.mp4", time: "2024", place: "New York" },
  { imgSrc: "/assets/sports8.png", time: "2025", place: "New York" },
  { imgSrc: "/assets/sports7.png", time: "2026", place: "New York" },
];

const isVideo = (src) => /\.(mp4|webm|ogg)$/i.test(src);

export default function MujiPhotoPlayer() {
  const [currentIdx, setCurrentIdx] = useState(0);
  const [nextIdx, setNextIdx] = useState(1);
  const [displayedIdx, setDisplayedIdx] = useState(0);

  const [maskProgress, setMaskProgress] = useState(0);
  const [animating, setAnimating] = useState(false);

  const rafRef = useRef(null);

  const reveal = Math.max(0, Math.min(1, maskProgress));

  const handleClick = () => {
    if (animating) return;

    const newNext = (currentIdx + 1) % data.length;
    setNextIdx(newNext);
    setAnimating(true);
    setMaskProgress(0);

    let start = null;

    const anticipationDuration = 180;
    const anticipationAmount = -0.1;
    const mainDuration = 420;
    const total = anticipationDuration + mainDuration;

    function animate(ts) {
      if (!start) start = ts;
      const elapsed = ts - start;

      if (elapsed < anticipationDuration) {
        const t = elapsed / anticipationDuration;
        const ease = 1 - Math.pow(1 - t, 2);
        setMaskProgress(ease * anticipationAmount);
      } else {
        const t = Math.min(
          (elapsed - anticipationDuration) / mainDuration,
          1
        );
        setMaskProgress(t * t);
      }

      if (elapsed < total) {
        rafRef.current = requestAnimationFrame(animate);
      } else {
        // 🔑 Freeze fully revealed
        setMaskProgress(1);

        // 🔑 Swap AFTER paint
        requestAnimationFrame(() => {
          setCurrentIdx(newNext);
          setDisplayedIdx(newNext);

          // 🔑 Reset mask one frame later
          requestAnimationFrame(() => {
            setMaskProgress(0);
            setAnimating(false);
          });
        });
      }
    }

    rafRef.current = requestAnimationFrame(animate);
  };

  useEffect(() => () => cancelAnimationFrame(rafRef.current), []);

  return (
    <div
    className = "page"
      onClick={handleClick}
style = { { padding : 0, margin : 0} }
      >
        <div style = { { display : "flex", flexDirection : "column", alignItems : "center", padding : 0 } }>
          <div style = { { height : "2px", background : "var(--black8)", width : "90%", marginBottom : "4px" } }/>
          <div style = { { height : "2px", background : "var(--black8)", width : "95%", marginBottom : "4px" } }/>
        </div>
        
    <div
          
      style={{
        aspectRatio: "16 / 9",
        position: "relative",
        overflow: "hidden",
        cursor: "pointer",
        userSelect: "none",
      }}
    >
      {/* Text overlay */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          zIndex: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "8px",
          color: "white",
          pointerEvents: "none",
          background: "var(--black8)",
        }}
      >
        <SlideInOutText2
          key={displayedIdx}
          txt={data[displayedIdx].time}
          prevTxt={data[(displayedIdx - 1 + data.length) % data.length].time}
          fontSize="40px"
        />
 <p style = { { color : "white", fontSize : "var(--font-size-teeny)", fontFamily : "var(--font-Source)", fontWeight : "400" } }>{ data[displayedIdx].place }</p>
        </div>
        {isVideo(data[currentIdx].imgSrc)  && (<p style = { { position : "absolute", bottom : 0, right : 4, zIndex : 4, color : "white", fontSize : "var(--font-size-teeny)", fontWeight : "500" } }>made with Team Stamps</p>)}

      {/* CURRENT */}
      {isVideo(data[currentIdx].imgSrc) ? (
        <video
          src={data[currentIdx].imgSrc}
          autoPlay
          loop
          playsInline
          style={{
            position: "absolute",
            inset: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            zIndex: 1,
            transform: animating
              ? `translateY(${-maskProgress * 24}px)`
              : "none",
          }}
        />
      ) : (
        <img
          src={data[currentIdx].imgSrc}
          alt=""
          style={{
            position: "absolute",
            inset: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            zIndex: 1,
            transform: animating
              ? `translateY(${-maskProgress * 24}px)`
              : "none",
          }}
        />
      )}

      {/* NEXT (always mounted) */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          zIndex: 2,
          pointerEvents: "none",
          opacity: animating && reveal > 0 ? 1 : 0,
        }}
      >
        {isVideo(data[nextIdx].imgSrc) ? (
          <video
            src={data[nextIdx].imgSrc}
            autoPlay
            loop
            muted
            playsInline
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              WebkitMaskImage: `linear-gradient(
                to top,
                black ${reveal * 100}%,
                transparent ${reveal * 100}%
              )`,
              maskImage: `linear-gradient(
                to top,
                black ${reveal * 100}%,
                transparent ${reveal * 100}%
              )`,
            }}
          />
        ) : (
          <img
            src={data[nextIdx].imgSrc}
            alt=""
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              WebkitMaskImage: `linear-gradient(
                to top,
                black ${reveal * 100}%,
                transparent ${reveal * 100}%
              )`,
              maskImage: `linear-gradient(
                to top,
                black ${reveal * 100}%,
                transparent ${reveal * 100}%
              )`,
            }}
          />
        )}
      </div>
    </div>
    </div>
  );
}
